export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13769.db0d4be4.jpg";